import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateNoTask = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 436,
	height: 436,
	viewBox: "0 0 436 436",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11025_42979)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M214.513 418.407C313.78 418.407 394.252 337.935 394.252 238.668C394.252 139.4 313.78 58.9282 214.513 58.9282C115.245 58.9282 34.7734 139.4 34.7734 238.668C34.7734 337.935 115.245 418.407 214.513 418.407Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M401.466 109.24H358.324C350.385 109.24 343.949 115.676 343.949 123.615V166.757C343.949 174.696 350.385 181.132 358.324 181.132H401.466C409.405 181.132 415.841 174.696 415.841 166.757V123.615C415.841 115.676 409.405 109.24 401.466 109.24Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M394.019 144.954H363.748V164.493H394.019V144.954Z",
				stroke: "#9EC5FF",
				strokeWidth: 2.78415,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M398.736 134.75H359.031V144.953H398.736V134.75Z",
				stroke: "#9EC5FF",
				strokeWidth: 2.78415,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M378.883 134.338V164.243",
				stroke: "#9EC5FF",
				strokeWidth: 2.78415,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M366.558 134.732L365.914 134.088C363.882 132.056 363.882 128.753 365.914 126.721C367.945 124.689 371.248 124.689 373.28 126.721L377.066 130.507C378.23 131.671 378.731 133.246 378.561 134.759",
				stroke: "#9EC5FF",
				strokeWidth: 2.78415,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M391.199 134.732L391.844 134.088C393.876 132.056 393.876 128.753 391.844 126.721C389.812 124.689 386.509 124.689 384.477 126.721L380.691 130.507C379.528 131.671 379.026 133.246 379.196 134.759",
				stroke: "#9EC5FF",
				strokeWidth: 2.78415,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.4184 172.423H14.3565C6.42734 172.423 -0.000488281 178.851 -0.000488281 186.78V229.842C-0.000488281 237.771 6.42734 244.199 14.3565 244.199H57.4184C65.3475 244.199 71.7753 237.771 71.7753 229.842V186.78C71.7753 178.851 65.3475 172.423 57.4184 172.423Z",
				fill: "#E7EBEE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M57.5434 172.306H14.4815C6.55234 172.306 0.124512 178.734 0.124512 186.663V229.725C0.124512 237.654 6.55234 244.082 14.4815 244.082H57.5434C65.4725 244.082 71.9003 237.654 71.9003 229.725V186.663C71.9003 178.734 65.4725 172.306 57.5434 172.306Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.7085 190.861H46.7581",
				stroke: "#9EC5FF",
				strokeWidth: 3.66508,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0508 202.202H56.0849",
				stroke: "#9EC5FF",
				strokeWidth: 3.66508,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.9588 190.861H51.099C53.8559 190.861 56.0846 193.099 56.0846 195.847V220.685C56.0846 223.442 53.8469 225.671 51.099 225.671H22.4299C19.6731 225.671 17.4443 223.433 17.4443 220.685V195.847C17.4443 193.09 19.682 190.861 22.4299 190.861H28.7849",
				stroke: "#9EC5FF",
				strokeWidth: 3.66508,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.8091 186.466V195.345",
				stroke: "#9EC5FF",
				strokeWidth: 3.66508,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.666 186.466V195.345",
				stroke: "#9EC5FF",
				strokeWidth: 3.66508,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M128.782 80.6157H301.325C312.057 80.6157 320.775 89.3337 320.775 100.066V321.327C320.775 332.059 312.057 340.777 301.325 340.777H128.782C118.05 340.777 109.332 332.059 109.332 321.327V100.066C109.332 89.3337 118.05 80.6157 128.782 80.6157Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M301.325 86.1466C308.995 86.1466 315.243 92.3942 315.243 100.065V321.327C315.243 328.997 309.004 335.245 301.325 335.245H128.782C121.111 335.245 114.863 328.997 114.863 321.327V100.065C114.863 92.3942 121.111 86.1466 128.782 86.1466H301.325ZM301.325 75.0835H128.782C114.989 75.0835 103.8 86.2629 103.8 100.065V321.327C103.8 335.12 114.98 346.308 128.782 346.308H301.325C315.118 346.308 326.306 335.129 326.306 321.327V100.065C326.306 86.2719 315.127 75.0835 301.325 75.0835Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.342 288.917H280.774",
				stroke: "#DCEBFE",
				strokeWidth: 6.71025,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.342 309.682H280.774",
				stroke: "#DCEBFE",
				strokeWidth: 6.71025,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M217.529 267.739C248.944 267.739 274.411 242.272 274.411 210.857C274.411 179.442 248.944 153.976 217.529 153.976C186.114 153.976 160.647 179.442 160.647 210.857C160.647 242.272 186.114 267.739 217.529 267.739Z",
				fill: "#C2F4F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M201.597 213.042L213.224 224.678L237.731 200.171",
				stroke: "#272769",
				strokeWidth: 10.4297,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.342 112.158H280.774",
				stroke: "#DCEBFE",
				strokeWidth: 6.71025,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.342 132.923H280.774",
				stroke: "#DCEBFE",
				strokeWidth: 6.71025,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M435.998 219.208C436.025 219.763 435.81 220.309 435.416 220.703L421.462 234.657C421.113 235.006 420.656 235.257 420.164 235.301C419.573 235.346 419.009 235.14 418.588 234.729L412.583 228.723C412.189 228.329 411.974 227.783 412.001 227.228C412.028 226.673 412.287 226.145 412.726 225.796C413.505 225.151 414.695 225.232 415.429 225.966L419.958 230.495C419.958 230.495 420.012 230.513 420.03 230.495L432.57 217.955C433.312 217.212 434.494 217.14 435.273 217.785C435.702 218.143 435.962 218.662 435.989 219.226L435.998 219.208Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M286.477 19.4551C286.504 20.0101 286.289 20.556 285.895 20.9499L271.941 34.904C271.592 35.2531 271.135 35.5037 270.643 35.5485C270.052 35.5933 269.488 35.3874 269.068 34.9757L263.062 28.9697C262.668 28.5759 262.453 28.0299 262.48 27.475C262.507 26.92 262.766 26.3919 263.205 26.0428C263.984 25.3984 265.174 25.4789 265.908 26.2129L270.437 30.742C270.437 30.742 270.491 30.7599 270.509 30.742L283.049 18.202C283.791 17.4591 284.973 17.3875 285.752 18.0319C286.181 18.39 286.441 18.9091 286.468 19.473L286.477 19.4551Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M222.935 371.818C222.962 372.373 222.747 372.919 222.353 373.313L208.399 387.267C208.05 387.616 207.593 387.867 207.101 387.912C206.51 387.957 205.946 387.751 205.526 387.339L199.52 381.333C199.126 380.939 198.911 380.393 198.938 379.838C198.965 379.283 199.224 378.755 199.663 378.406C200.442 377.762 201.632 377.842 202.366 378.576L206.895 383.105C206.895 383.105 206.949 383.123 206.967 383.105L219.507 370.565C220.249 369.822 221.431 369.751 222.21 370.395C222.639 370.753 222.899 371.272 222.926 371.836L222.935 371.818Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M56.1467 283.717C56.1825 284.576 55.8603 285.408 55.2606 286.017L33.8236 307.454C33.2866 307.991 32.5884 308.376 31.8276 308.439C30.9146 308.51 30.0464 308.197 29.4109 307.561L20.1827 298.333C19.5741 297.725 19.2518 296.892 19.2966 296.033C19.3324 295.183 19.7441 294.377 20.4065 293.831C21.5969 292.846 23.4229 292.963 24.5596 294.099L31.5143 301.054C31.5143 301.054 31.5949 301.081 31.6217 301.054L50.8837 281.792C52.0204 280.656 53.8464 280.539 55.0368 281.524C55.6992 282.07 56.1019 282.875 56.1377 283.735L56.1467 283.717Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M357.473 282.042H301.066C290.68 282.042 282.26 290.462 282.26 300.848V357.255C282.26 367.641 290.68 376.061 301.066 376.061H357.473C367.859 376.061 376.279 367.641 376.279 357.255V300.848C376.279 290.462 367.859 282.042 357.473 282.042Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M339.742 314.23C336.108 310.766 330.827 309.414 325.994 310.023C321.93 310.533 317.132 313.702 317.061 318.311C316.98 323.198 322.243 325.66 326.289 326.644C330.505 327.674 335.266 328.023 338.757 330.878C342.991 334.342 342.167 340.106 337.943 343.15C335.499 344.94 332.286 345.924 328.867 345.924C323.389 345.871 318.699 343.06 315.727 340.715",
				stroke: "#9EC5FF",
				strokeWidth: 5.68794,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M328.634 302.218V309.88",
				stroke: "#9EC5FF",
				strokeWidth: 5.68794,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M328.634 345.924V353.586",
				stroke: "#9EC5FF",
				strokeWidth: 5.68794,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70.2358 90.3545H85.649",
				stroke: "#6BA6FF",
				strokeWidth: 6.52536,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.2896 56.0015L92.1826 66.8945",
				stroke: "#6BA6FF",
				strokeWidth: 6.52536,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M115.446 44.9468V60.3599",
				stroke: "#6BA6FF",
				strokeWidth: 6.52536,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11025_42979",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 436,
			height: 436,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateNoTask;
